var _defs, _text, _text2, _tspan, _tspan2, _tspan3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTitleEn = function SvgTitleEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "title_en_svg__Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 720 75.32",
    "aria-labelledby": "Preorder in easy mode"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".title_en_svg__cls-5{font-family:inherit;font-size:inherit;fill:#ffd14f}"))), /*#__PURE__*/React.createElement("g", {
    id: "title_en_svg__HOME"
  }, /*#__PURE__*/React.createElement("g", {
    id: "title_en_svg__PRESENTATION"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "title_en_svg__cls-5",
    transform: "translate(0 59.06)",
    id: "title_en_svg__Preorder_in_easy_mode",
    "data-name": "Preorder in easy mode"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PREORDER IN EASY MODE"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "title_en_svg__cls-5",
    transform: "translate(5 54.06)",
    id: "title_en_svg__Preorder_in_easy_mode-2",
    "data-name": "Preorder in easy mode"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PREORDER IN EASY MODE"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 54.06)",
    style: {
      fill: "#bee5cf",
      fontFamily: "inherit",
      fontSize: "inherit"
    },
    id: "title_en_svg__Preorder_in_easy_mode-3",
    "data-name": "Preorder in easy mode"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PREORDER IN EASY MODE"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(5 59.06)",
    style: {
      fill: "#ef9f99",
      fontFamily: "inherit",
      fontSize: "inherit"
    },
    id: "title_en_svg__Preorder_in_easy_mode-4",
    "data-name": "Preorder in easy mode"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PREORDER IN EASY MODE"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(3 57.06)",
    style: {
      fontFamily: "inherit",
      fontSize: "inherit",
      fill: "#4c4c4c"
    },
    id: "title_en_svg__Preorder_in_easy_mode-5",
    "data-name": "Preorder in easy mode"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PREORDER IN EASY MODE"))))));
};
export default SvgTitleEn;